// extracted by mini-css-extract-plugin
module.exports = {"container":"ReferralTermAndConditions_container__1AP5M","rtl":"ReferralTermAndConditions_rtl__1E4sk"};